
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Eyelid_carcinoma",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Eyelid_carcinoma.vue